import {

    SET_TEMPLATEDROPDOWNVALUE_ARD,
    SET_URGENTDROPDOWNVALUE_ARD,
    SET_ISSENDAPPROVAL_ARD,
    SET_ISADDTEMPLATE_ARD,
    SET_APPROVALREQDATA,
    SET_ISEDITTEMPLATE_ARD,
    SET_REASONINBRIEF_ARD,
    SET_REASONCODEDROPDOWNVALUE_ARD,
    SET_SOURCEDOWNVALUE_ARD
} from './mmApprovalReqDetailsAction';

const initialState = {
    isSendApproval: false,
    isEditTemplate: false,
    isAddTemplate: false,
    approvalReqData: {},
    templateDropdownValue: "",
    urgentDropdownValue: "Select Urgency",
    sourceDropdownValue: "Select Source",
    reasonCodeDropdownValue: "Select Reason Code",
    resonInBrief: '',

};
const mmApprovalReqDetails = (state = initialState, action) => {
    switch (action.type) {

        case SET_SOURCEDOWNVALUE_ARD:
            return Object.assign({}, state, {
                sourceDropdownValue: action.value
            })
        case SET_REASONCODEDROPDOWNVALUE_ARD:
            return Object.assign({}, state, {
                reasonCodeDropdownValue: action.value
            })
        case SET_TEMPLATEDROPDOWNVALUE_ARD:
            return Object.assign({}, state, {
                templateDropdownValue: action.value
            })
        case SET_URGENTDROPDOWNVALUE_ARD:
            return Object.assign({}, state, {
                urgentDropdownValue: action.value
            })
        case SET_ISSENDAPPROVAL_ARD:
            return Object.assign({}, state, {
                isSendApproval: action.value
            })
        case SET_REASONINBRIEF_ARD:
            return Object.assign({}, state, {
                resonInBrief: action.value
            })
        case SET_ISEDITTEMPLATE_ARD:
            return Object.assign({}, state, {
                isEditTemplate: action.value
            })
        case SET_ISADDTEMPLATE_ARD:
            return Object.assign({}, state, {
                isAddTemplate: action.value
            })
        case SET_APPROVALREQDATA:
            return Object.assign({}, state, {
                approvalReqData: action.value
            })
        default:
            return state;
    }
}
export default mmApprovalReqDetails;